import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {CommonFormService} from 'src/app/shared/utils/common-form.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../../diccionarios/moduloVMI';
import {VmiArticulosService} from '../../../services/administracion/vmi-articulos.service';
import {AG_GRID_LOCALE_ES} from '../../../diccionarios/spanishAgGrid';
import {ArticuloModel} from '../../../models/vmi-articuloModel';

@Component({
  selector: 'app-vmi-frm-mantenedor-articulos',
  templateUrl: './vmi-frm-mantenedor-articulos.component.html',
  styleUrls: ['./vmi-frm-mantenedor-articulos.component.css']
})
export class VmiFrmMantenedorArticulosComponent implements OnInit {

  formulario: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  loading: boolean = false;
  listaVacia: boolean = true;

  textBoton: string;
  textoBuscar: string;
  mostrarFormulario: boolean = false;

  modulo: any = {};
  editableForm: boolean = false;

  DAT_TITULOS: any;
  titulo: any;
  AG_GRID_LOCALE_ES: any = {};

  constructor(
    private fb: FormBuilder,
    private _utils: UtilsService,
    private commonFormService: CommonFormService,
    private _articulos: VmiArticulosService
  ) {
  }

  ngOnInit(): void {
    this.modulo = moduloVMI;
    this.textBoton = this.modulo.button.buttonsNombre.guardar;
    this.AG_GRID_LOCALE_ES = AG_GRID_LOCALE_ES;
    this.DAT_TITULOS = this.modulo.titulos.articulo;
    this.titulo = this.DAT_TITULOS.tituloCardListar;

    this.formulario = this.fb.group({
      artId: [''],
      artDescripcion: ['', [Validators.required]],
      artUndStock: ['', [Validators.required]],
      artCodigoInterno: ['', [Validators.required]],
      artCont: [''],
      artEstado: [''],
    });

    this.gridComponent();
    this.getAll();
  }

  //*SERVICIOS
  getAll() {
    this._articulos.getAll().subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = (this.rowData.length === 0) ? true : false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  gridComponent() {
    this.columnDefs = [
      {
        headerName: 'No',
        field: 'artId',
        sortable: true,
        filter: true,
        width: 130
      },
      {
        headerName: 'DESCRIPCIÓN',
        field: 'artDescripcion',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'UNIDAD',
        field: 'artUndStock',
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'CNTR',
        field: 'artCont',
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'CÓDIGO INTERNO',
        field: 'artCodigoInterno',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'ESTADO',
        field: 'artEstado',
        sortable: true,
        filter: true,
        width: 200,
        valueGetter: function (data) {
          return data.data.artEstado === 1 ? 'ACTIVO' : 'INACTIVO';
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.modulo.button.buttonsNombre.editar,
          colorBoton: this.modulo.button.buttonsCss.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.modulo.button.buttonsNombre.eliminar,
          colorBoton: this.modulo.button.buttonsCss.danger
        }
      }
    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
  }

  editar({rowData}) {
    const obj: ArticuloModel = {
      artId: rowData.artId,
      artDescripcion: rowData.artDescripcion === undefined ? '' : rowData.artDescripcion,
      artUndStock: rowData.artUndStock === undefined ? '' : rowData.artUndStock,
      artCodigoInterno: rowData.artCodigoInterno === undefined ? '' : rowData.artCodigoInterno,
      artCont: rowData.artCont === undefined ? '' : rowData.artCont,
      artEstado: rowData.artEstado === undefined ? '' : rowData.artEstado,
    };
    this.commonFormService.abrirFormularioParaEditar(this, obj);
    this.titulo = this.DAT_TITULOS.tituloCardEditar
  }

  eliminar({rowData}) {
    const articulo: ArticuloModel = rowData;
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.eliminar,
      text: ``,
      action: this.modulo.button.buttonsNombre.eliminar,
      funcion: this._articulos.delete(articulo.artId),
    }).then((res: any) => {
      this.getAll();
    }).catch((err) => {
      console.log(err);
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizar();
      } else {
        this.guardar();
      }
    } else {
      this.regresar();
    }
  }

  guardar() {
    const articulo = new ArticuloModel(this.formulario.value);
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.guardar,
      text: ``,
      action: this.modulo.button.buttonsNombre.guardar,
      funcion: this._articulos.create(articulo),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  actualizar() {
    const articulo = new ArticuloModel(this.formulario.value);
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.actualizar,
      text: ``,
      action: this.modulo.button.buttonsNombre.actualizar,
      funcion: this._articulos.edit(articulo),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  regresar() {
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.commonFormService.limpiarYregrear(this);
  }

}
